// extracted by mini-css-extract-plugin
module.exports = {"registerOfflineProductViewWrapper":"RegisterOfflineProductView_registerOfflineProductViewWrapper__ib_xH"};